import React from "react";
import HomeBanner from "./HomeBanner";
import EmployeeExperience from "./EmployeeExperience";
import ServiiceCard from '../Services/ServicesCard'

import TransformingWorkplaces from "./TransformingWorkplaces";
import ServicesCard from "../Services/ServicesCard";

const MainHome = () => {
  return (
    <div>
      <HomeBanner />
      <EmployeeExperience />
      <ServicesCard />
    </div>
  );
};

export default MainHome;
